import { render, staticRenderFns } from "./CompanyConfigDetails.vue?vue&type=template&id=72f5db72&"
import script from "./CompanyConfigDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyConfigDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyConfigDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports